<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
========================================================================================== -->

<template>
<div id="societe">
    <div class="vx-card">
        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>Gestion Société</h4>
            </div>
        </div>
        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full">
                        <div class="w-full mt-4">
                            <label class="mt-2">Nom du société</label>

                            <div class="mt-2">
                                <vs-input class="w-full" icon-pack="feather" icon="icon-info" v-model="data_local.societe.nom" v-validate="'required'" name="nom" />

                                <span class="text-danger text-sm" v-show="errors.has('nom')">{{ errors.first('nom') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="vx-col md:w-1/3 w-full">
                        <div class="w-full mt-4">
                            <label class="mt-2">Pays</label>

                            <div class="mt-2">
                                <v-select v-validate="'required'" label="designation" value="id" v-model="data_local.societe.pays" :options="listPays" name="pays" />

                                <span class="text-danger text-sm" v-show="errors.has('pays')">{{ errors.first('pays') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="vx-col md:w-1/3 w-full">
                        <div class="w-full mt-4">
                            <label class="mt-2">Gouvernorat</label>

                            <div class="mt-2">
                                <v-select v-validate="'required'" label="designation" value="id" v-model="data_local.societe.gouvernorat" :options="listGouvs" name="gouvernorat" />

                                <span class="text-danger text-sm" v-show="errors.has('gouvernorat')">{{ errors.first('gouvernorat') }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Content Row -->

                <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full">
                        <div class="w-full mt-4">
                            <label class="mt-2">Ville</label>

                            <div class="mt-2">
                                <v-select v-validate="'required'" label="designation" value="id" v-model="data_local.societe.ville" :options="filteredVilles" name="ville" />

                                <span class="text-danger text-sm" v-show="errors.has('ville')">{{ errors.first('ville') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="vx-col md:w-1/2 w-full">
                        <div class="w-full mt-4">
                            <label class="mt-2">Adresse</label>

                            <div class="mt-2">
                                <vs-input class="w-full" icon-pack="feather" icon="icon-map-pin" v-model="data_local.societe.adresse" v-validate name="adresse" />

                                <span class="text-danger text-sm" v-show="errors.has('adresse')">{{ errors.first('adresse') }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Content Row -->

                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full">
                        <div class="w-full mt-4">
                            <label class="mt-2">Téléphone</label>

                            <div class="mt-2">
                                <vs-input class="w-full" icon-pack="feather" icon="icon-phone" v-model="data_local.societe.telephone" v-validate name="telephone" />

                                <span class="text-danger text-sm" v-show="errors.has('telephone')">{{ errors.first('telephone') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="vx-col md:w-1/3 w-full">
                        <div class="w-full mt-4">
                            <label class="mt-2">Fax</label>

                            <div class="mt-2">
                                <vs-input class="w-full" icon-pack="feather" icon="icon-printer" v-model="data_local.societe.fax" v-validate name="fax" />

                                <span class="text-danger text-sm" v-show="errors.has('fax')">{{ errors.first('fax') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="vx-col md:w-1/3 w-full">
                        <div class="w-full mt-4">
                            <label class="mt-2">Site Web</label>

                            <div class="mt-2">
                                <vs-input class="w-full" icon-pack="feather" icon="icon-chrome" v-model="data_local.societe.siteWeb" v-validate name="siteWeb" />

                                <span class="text-danger text-sm" v-show="errors.has('siteWeb')">{{ errors.first('siteWeb') }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <br />
                <br />

                <!-- Save & Reset Button -->

                <div class="vx-row" v-if="haveRoleAdmin()">
                    <div class="vx-col w-full">
                        <div class="mt-8 flex flex-wrap items-center justify-end">
                            <vs-button class="ml-auto mt-2" :disabled="!validateForm" @click="save_changes">Confirmer</vs-button>

                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Initialiser</vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import vSelect from "vue-select";
//import moduleUserManagement from "@/store/user-management/moduleUserManagement.js"
import authService from "@/auth/authService.js";

export default {
    components: {
        "v-select": vSelect
    },
    data() {
        return {
            data_local: JSON.parse(JSON.stringify(this.$store.state.AppActiveUser)),
            listPays: [],
            listGouvs: [],
            listVilles: []
        };
    },
    computed: {
        validateForm() {
            return !this.errors.any();
        },
        filteredVilles() {
            try {
                return this.listVilles.filter(
                    listVilles =>
                    listVilles.idGouvernorat === this.data_local.societe.gouvernorat.id
                );
            } catch {
                return this.listVilles.filter(
                    listVilles => listVilles.idGouvernorat === -1
                );
            }
        }
    },

    methods: {
        haveRoleAdmin() {
            return authService.getRole().includes('SuperAdmin')
        },
        load_data() {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    if (this.$store.state.AppActiveUser)
                        resolve(
                            JSON.parse(JSON.stringify(this.$store.state.AppActiveUser))
                        );
                    else
                        reject(JSON.parse(JSON.stringify(this.$store.state.AppActiveUser)));
                }, 50);
            });
        },
        reset_data() {
            this.data_local = JSON.parse(
                JSON.stringify(this.$store.state.AppActiveUser)
            );
        },
        save_changes() {
            if (!this.validateForm) return;

            this.$vs.loading();
            const payload = {
                DataBody: {
                    libelle: this.data_local.societe.nom,
                    adresse: this.data_local.societe.adresse,
                    telephone: this.data_local.societe.telephone,
                    fax: this.data_local.societe.fax,
                    webSite: this.data_local.societe.siteWeb,
                    ville: this.data_local.societe.ville.id
                },
                id: this.data_local.id
            };

            this.$store
                .dispatch("moduleusermanagement/UpdateSociete", payload)
                .then(() => {
                    this.$vs.loading.close();
                    this.$swal.fire({
                        position: "absolute",
                        icon: "success",
                        title: "Société modifié avec succès .",
                        showConfirmButton: true,
                        timer: 2500
                    });
                })
                .catch(error => {
                    this.$vs.loading.close();
                    this.$swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: error.message
                    });
                    this.data_local = JSON.parse(
                        JSON.stringify(this.$store.state.AppActiveUser)
                    );
                });
        }
    },
    created() {
        this.$vs.loading();
        this.$store
            .dispatch("moduleusermanagement/GetLocations")
            .then(response => {

                this.listPays = response.data.pays;
                this.listGouvs = response.data.gouv;
                this.listVilles = response.data.villes;
                this.$vs.loading.close();
            })
            .catch(error => {
                console.log(error);
                this.$vs.loading.close();
                this.$router.push("/pages/error-500");
            });
        this.$store.subscribe((mutation, state) => {
            console.log(mutation.type)

            if (mutation.type === "UPDATE_USER_INFO")
                this.data_local = JSON.parse(JSON.stringify(state.AppActiveUser));

        })
    }
};
</script>

<style scoped>
#societe {
    padding-top: 50px;
    padding-right: 50px;
    padding-bottom: 50px;
    padding-left: 50px;
}
</style>
